import styled from 'styled-components';
import { Table } from 'antd';

export const HeaderTableWrapper = styled.input`
  background: transparent;
  border: 1px dashed transparent;
  transition: all 0.3s;
  padding-left: 5px;
  transform: translate(-5px, 0px);
  text-transform: uppercase;
  &:hover {
    border: 1px dashed ${({ theme }) => theme.border.default};
  }
  &:focus {
    border: 1px dashed ${({ theme }) => theme.palette.primary};
    outline: none;
    background: ${({ theme }) => theme.background.content};
    transform: translate(0px, 0px);
  }
  &:disabled {
    border: 1px dashed transparent;
  }
  .highlightFilter {
    color: ${({ theme }) => theme.palette.primary};
  }
`;

export const IconWrapper = styled.span`
  &.highlightFilter {
    color: ${({ theme }) => theme.palette.primary} !important;
    path {
      fill: ${({ theme }) => theme.palette.primary};
    }
  }
`;

export const DropdownStyles = styled.div`
  .search-button {
    i {
      color: white;
    }
  }
`;

export const TableStyles = styled(Table)`
  .ant-table-thead > tr > th {
    background: ${({ theme }) => theme.table.headerBackground} !important;
    color: ${({ theme }) => theme.table.headerColor} !important;
    font-size: 13px !important;
    font-weight: 700 !important;
  }
  .ant-table-tbody > tr:last-child > td {
    border: none !important;
  }
  .ant-table-tbody > tr.ant-table-placeholder > td {
    padding: 16px 10px;
  }
`;
